/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { PERMISSION_NAMES } from 'blb-types/blendBridge';
import { RoutePermissions } from 'blb-utils/permissions';
import { TabType } from 'src/components/AuthenticatedApp/ProfilePage';

export const tabPermissionMap: Record<TabType, RoutePermissions> = {
  Branches: {},
  Credentials: { [PERMISSION_NAMES.BridgeCredentials]: ['notary'] },
  Journal: { [PERMISSION_NAMES.BSRJournal]: ['notary'] },
  Profile: { [PERMISSION_NAMES.BridgeProfile]: ['notary'] },
  'Room Assignment': { [PERMISSION_NAMES.BSRRooms]: ['notary'] },
};
